import { Navigate } from 'react-router-dom';
import React, { Fragment } from 'react';
import { useUser } from 'app/shared/contexts/user';
import { useApi } from 'app/shared/contexts/api';

interface PrivateProps {
  redirectTo?: string;
  children: React.ReactNode;
}
export const Private = ({ redirectTo = '/error', children }: PrivateProps) => {
  const { user, isLoading } = useUser();
  const authToken = useApi('authToken');

  // Auth loading is gated once, up in AppContentWrapper's aggregate skeleton, so by
  // the time Private renders the user is resolved. Only the auth-failure redirect
  // remains here. (The `!isLoading` guard is kept defensively so a stray render mid-
  // load can't redirect before the user query settles.)
  if (!authToken || (!isLoading && !user)) {
    return <Navigate to={redirectTo} />;
  }

  // Wrapped in a React Fragment intentionally
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <Fragment>{children}</Fragment>;
};
